import React, { useState } from "react";
import HeaderComponent from "components/card/HeaderComponent";
import Leaderboards from "./Leaderboards";

const LeaderboardSummary = (props) => {
  

  return (
    <HeaderComponent
      title="Team Leaderboard"
      titleClass="text-[16px] font-medium"
      description="Top performers this month based on gift credits earned"
      descriptionClass="text-sm"
    >
      <div className="max-h-[600px] overflow-y-auto">
        <Leaderboards/>
      </div>
    </HeaderComponent>
  );
};

export default LeaderboardSummary;
